import { FormattedMessage } from 'react-intl';

export interface OfferingNameProps {
  name: string;
}

/**
 * Component to display the name of an offering, if there's any special logic necessary for showing the name it can go
 * here.
 */
export const OfferingName = ({ name }: OfferingNameProps) => {
  switch (name) {
    case 'The 100':
      return <FormattedMessage id="the-100" defaultMessage="The 💯" />;
    default:
      return <>{name}</>;
  }
};
